import { UmDashboardActionTypes } from '../constants/um-action-types';
import { UserInformation, UserRequest } from '../../services/UserManagementService';
import { SortDescriptor } from '@react-spectrum/s2/node_modules/@react-types/shared/src/collections';

export interface UMDashboardReducerFilterInterface {
    filterPlatform: string;
    filterRole: string;
    filterPermissions: string;
    filterLocale: string;
    sortDescriptor: SortDescriptor;
    searchStr: string;
    searchFrom: number;
    searchSize: number;
}

export interface UMDashboardReducerInterface extends UMDashboardReducerFilterInterface {
    dataAllUsers: UserInformation[];
    dataAllUserRequests: UserRequest[];
}

const initialFilters = {
    filterPlatform: 'all',
    filterRole: 'all',
    filterPermissions: 'all',
    filterLocale: 'all',
    sortDescriptor: { column: '', direction: 'descending' } as SortDescriptor,
    searchFrom: 0,
    searchSize: 20,
} as UMDashboardReducerFilterInterface;

const intialState = {
    dataAllUsers: [],
    dataAllUserRequests: [],
    ...initialFilters,
};

export const umDashboardDataReducer = (state = intialState, { type, payload }) => {
    switch (type) {
        case UmDashboardActionTypes.UPDATE_UM_DASHBOARD_DATA_ALL_USERS:
            return { ...state, dataAllUsers: JSON.parse(JSON.stringify(payload)) };
        case UmDashboardActionTypes.UPDATE_UM_DASHBOARD_DATA_ALL_USER_REQUESTS:
            return { ...state, dataAllUserRequests: JSON.parse(JSON.stringify(payload)) };
        case UmDashboardActionTypes.UPDATE_UM_DASHBOARD_FILTER_PLATFORM:
            return { ...state, filterPlatform: payload };
        case UmDashboardActionTypes.UPDATE_UM_DASHBOARD_FILTER_ROLE:
            return { ...state, filterRole: payload };
        case UmDashboardActionTypes.UPDATE_UM_DASHBOARD_FILTER_PERMISSIONS:
            return { ...state, filterPermissions: payload };
        case UmDashboardActionTypes.UPDATE_UM_DASHBOARD_FILTER_LOCALE:
            return { ...state, filterLocale: payload };
        case UmDashboardActionTypes.UPDATE_UM_DASHBOARD_SORT_DESCRIPTOR:
            return { ...state, sortDescriptor: payload };
        case UmDashboardActionTypes.UPDATE_UM_DASHBOARD_SEARCH_STR:
            return { ...state, searchStr: payload };
        case UmDashboardActionTypes.UPDATE_UM_DASHBOARD_SEARCH_FROM:
            return { ...state, searchFrom: payload };
        case UmDashboardActionTypes.UPDATE_UM_DASHBOARD_SEARCH_SIZE:
            return { ...state, searchSize: payload };
        case UmDashboardActionTypes.UPDATE_UM_DASHBOARD_RESET_ALL_FILTERS:
            return { ...state, ...initialFilters };
        default:
            return state;
    }
};
